<template>
  <div class="card-header--form">
    <el-radio-group v-model="config.timeUnit"
                    @change="fetch"
                    style="vertical-align: top;">
      <el-radio-button label="D">按日统计</el-radio-button>
      <el-radio-button label="M">按月统计</el-radio-button>
      <el-radio-button label="Y">按年统计</el-radio-button>
    </el-radio-group>
    <el-date-picker style="width: 205px;margin-left: 5px;"
                    v-model="config.daterange"
                    type="daterange"
                    range-separator="-"
                    unlink-panels
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :clearable="false"
                    @change="fetch">
    </el-date-picker>
    <!-- <span class="form-label"
      v-if="userPermission.OPERATE">企业：</span>
    <assign-ent-select v-if="userPermission.OPERATE"
      showAll
      immediate
      v-model="config.vendorId"
      class="form--fix-style"
      :option="{}"
      :callback="fetch" /> -->
    <!-- <span class="form-label"
      v-if="userPermission.OPERATE">行业分类：</span>
    <supervise-cate-select v-if="userPermission.OPERATE"
      class="form--fix-style"
      showAll
      immediate
      v-model="config.categoryId"
      :callback="fetch"
      :option="{}" /> -->
    <!-- <span class="form-label"
      v-if="userPermission.ENT">标签类型：</span>
    <vendor-label-select v-if="userPermission.ENT"
      class="form--fix-style"
      v-model="config.tagType"
      :showAll="true"
      :callback="fetch"
      :option="{vendorId: userInfo.orgId}" /> -->
    <span class="form-label"
          v-if="userPermission.ENT">商品：</span>
    <vendor-product-select v-if="userPermission.ENT"
                           class="form--fix-style"
                           v-model="config.productId"
                           :showAll="true"
                           :callback="fetch"
                           :clearable="false"
                           :option="{vendorId: userInfo.orgId}" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// import AssignEntSelect from '@/components/business/assign-ent-select.vue'
// import VendorLabelSelect from '@/components/business/vendor-label-select.vue'
import VendorProductSelect from '@/components/business/vendor-product-select.vue'
// import SuperviseCateSelect from '@/components/business/supervise-cate-select.vue'
export default {
  name: 'scantag-form',
  components: { VendorProductSelect },
  props: {
    callBack: Function
  },
  data () {
    const end = new Date()
    const start = new Date()
    start.setMonth(start.getMonth() - 6)
    return {
      config: {
        daterange: [start, end],
        timeUnit: 'M',
        tagType: null,
        productId: null,
        vendorId: null,
        categoryId: null
      }
    }
  },
  watch: {},
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userPermission: state => state.account.permission
    })
  },
  methods: {
    formatPost () {
      let { timeUnit, tagType, productId, daterange, vendorId, categoryId } = this.config
      return {
        tagType,
        timeUnit,
        productIds: productId ? [productId] : null,
        beginDate: moment(daterange[0]).format('YYYYMMDD'),
        endDate: moment(daterange[1]).format('YYYYMMDD'),
        vendorId,
        categoryId
      }
    },
    fetch () {
      this.callBack(this.formatPost())
    }
  },
  created () { },
  mounted () {
    this.fetch()
  }
}
</script>
<style lang="stylus" scoped>
.form-label {
  line-height: 32px;
  font-size: 14px;
  margin-left: 5px;
}

.form--fix-style {
  width: 140px;
}
</style>
